<div class="actions">
  <a lfwShouldOpenInNewTab [routerLink]="order().canEdit() ? ['edit', order().id] : null">
    <button [disabled]="!order().canEdit()" mat-icon-button matTooltip="{{ 'ORDERS.EDIT' | translate }}">
      <mat-icon>edit</mat-icon>
    </button>
  </a>
  <a lfwShouldOpenInNewTab [routerLink]="['view', order().id]">
    <button matTooltip="{{ 'ORDERS.VIEW' | translate }}" mat-icon-button>
      <mat-icon>visibility</mat-icon>
    </button>
  </a>

  <button class="menu-trigger" mat-icon-button [matMenuTriggerFor]="actions">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #actions="matMenu">
    <button mat-menu-item (click)="openOrderInformation()">
      <mat-icon>info</mat-icon>
      <span>{{ 'ORDERS.INFO' | translate }}</span>
    </button>

    <a [routerLink]="['report', order().id]">
      <button mat-menu-item [disabled]="!order().hasReport">
        <mat-icon>receipt</mat-icon>
        <span>{{ 'ORDERS.REPORT' | translate }}</span>
      </button>
    </a>

    <lfw-menu-vertical-divider />
    <button mat-menu-item [disabled]="!order().canCheckOut()" (click)="checkoutOrder.emit(order())">
      <mat-icon>drive_file_move</mat-icon>
      <span>{{ 'ORDERS.CHECKOUT' | translate }}</span>
    </button>
  </mat-menu>
</div>

<button class="mobile-only-trigger" mat-icon-button [matMenuTriggerFor]="mobileActions">
  <mat-icon>more_vert</mat-icon>
</button>

<mat-menu class="mobile-only" #mobileActions="matMenu">
  <a lfwShouldOpenInNewTab [routerLink]="order().canEdit() ? ['edit', order().id] : null">
    <button [disabled]="!order().canEdit()" mat-menu-item>
      <mat-icon>edit</mat-icon>
      <span>{{ 'ORDERS.EDIT' | translate }}</span>
    </button>
  </a>
  <a lfwShouldOpenInNewTab [routerLink]="['view', order().id]">
    <button mat-menu-item>
      <mat-icon>visibility</mat-icon>
      <span>{{ 'ORDERS.VIEW' | translate }}</span>
    </button>
  </a>
  <button mat-menu-item (click)="openOrderInformation()">
    <mat-icon>info</mat-icon>
    <span>{{ 'ORDERS.INFO' | translate }}</span>
  </button>
  <a [routerLink]="['report', order().id]">
    <button mat-menu-item [disabled]="!order().hasReport">
      <mat-icon>receipt</mat-icon>
      <span>{{ 'ORDERS.REPORT' | translate }}</span>
    </button>
  </a>
  <lfw-menu-vertical-divider />
  <button mat-menu-item [disabled]="!order().canCheckOut()" (click)="checkoutOrder.emit(order())">
    <mat-icon>drive_file_move</mat-icon>
    <span>{{ 'ORDERS.CHECKOUT' | translate }}</span>
  </button>
</mat-menu>
